import * as React from 'react';
import { IMeta, InjectedFormProps } from 'models/common';
import renderIcon from 'helpers/renderIcon';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { Field } from 'redux-form';
import { PortalTextareaField } from './PortalTextareaField';

const TEXTAREA_USAGE = {
	portal: '',
	admin: 'portalAdminTextareaField',
};

interface IProps extends InjectedFormProps {
	usage?: 'portal' | 'admin';
	input: any;
	label?: any;
	rows?: number;
	meta?: IMeta;
	autoFocus?: any;
	readOnly?: boolean;
	description?: string;
	onChangeAction?: any;
	closeCommentBox?: () => void;
	customTitle: string;
	maxLength?: number;

	/* functions props */
	t?: (key: string) => string;
	handleSave?: () => void;
	handleSubmit: any;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class CommentBox extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
		this.handleClose = this.handleClose.bind(this);
		this.handleSave = this.handleSave.bind(this);
	}

	public handleClose() {
		if (this.props.closeCommentBox) {
			this.props.closeCommentBox();
		}
	}
	public handleSave() {
		if (this.props.handleSave) {
			this.props.handleSave();
		}
		if (this.props.closeCommentBox) {
			this.props.closeCommentBox();
		}
	}

	public render() {
		const { t, customTitle, input, maxLength } = this.props;
		const usage = this.props.usage ? TEXTAREA_USAGE[this.props.usage] : TEXTAREA_USAGE.portal;

		return (
			<div className="commentbox-wrapper">
				<div className="header d-flex flex-row justify-content-between align-items-center">
					<h2>{`${t('BSPortal_Common_Edit')} ${customTitle}`}</h2>
					<div className="pointer" onClick={() => this.handleClose()}>
						{renderIcon('cancel_search', 32, 32)}
					</div>
				</div>
				<Field
					name={input.name}
					component={PortalTextareaField}
					usage={usage}
					type="text"
					label={t('Magazine_Section_Manage_Common_Description')}
					maxLength={maxLength}
				/>
				<div className="bsPortalBtn btnPrimary" onClick={this.handleSave}>
					{t('BSPortal_Common_SaveChanges')}
				</div>
			</div>
		);
	}
}

export default CommentBox;
